import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDropdownComponent } from './user-dropdown/user-dropdown.component';
import { MenuModule } from 'primeng/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [CommonModule, MenuModule, FontAwesomeModule],
  declarations: [UserDropdownComponent],
  exports: [UserDropdownComponent]
})
export class HffCommonUiUserDropdown {}
